import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-catalog",
  "use": "icon-soc-l1-mall-catalog-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-catalog\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 192h640v128H192V192zm0 160h640v480H192V352zm96 96v64h448v-64H288zm0 128v64h448v-64H288zm0 128v64h320v-64H288z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-catalog.svg
// module id = hioc
// module chunks = 488